import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      '&$locked $titleText': {
        filter: 'blur(3px)',
      },
      '&$locked $industry': {
        filter: 'blur(3px)',
      },
      '&$locked $subtitle': {
        filter: 'blur(3px)',
      },
      '&$locked $score': {
        filter: 'blur(3px)',
      },
    },
    locked: {},
    titleScoreWrapper: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      columnGap: theme.spacing(1.5),
    },
    texts: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'flex-start',
      flex: '1',
    },
    title: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      width: '100%',
    },
    titleText: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(21),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.primary,
    },
    titleScoringMethod: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      textDecoration: 'underline',
    },
    tooltipText: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.white,
      '& p': {
        margin: theme.spacing(1, 0, 0),
      },
      '& span': {
        color: theme.palette.secondary.main,
      },
    },
    industry: {},
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.mediumGray,
    },
    badgeCustomModel: {
      marginLeft: 'auto',
    },
    similarityLabel: {
      display: 'inline-block',
    },
    score: {},
    buttonScoringMethod: {},
    stonlyHintIcon: {
      fontSize: theme.typography.pxToRem(12),
      marginLeft: theme.spacing(0.5),
    },
  }),
  { name: 'Header' }
);
